<template>
  <v-row justify="center">
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ $t("indirizzi.titolo") }} </span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <div
                class="
                  card card-nav-tabs
                  animate__animated animate__bounceInDown
                "
              >
                <h4
                  class="
                    card-header card-header-primary
                    font-weight-bold
                    grey
                    lighten-2
                    black--text
                    text--lighten-1
                    body-1
                    p-2
                  "
                >
                  {{ $t("indirizzi.residenza") }} 
                </h4>

                <div class="card-body">
                  <h4 class="card-title">
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="indirizzi.residenza.nazione"
                          :items="dd_nazioni"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          required
                          return-object
                          v-bind:label="$t('indirizzi.nazione') + '*'"
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="indirizzi.residenza.comune"
                          :items="dd_comuni_residenza"
                          item-text="DECODIF"
                          item-value="CODICECOMUNE"
                          v-bind:label="$t('indirizzi.comune') + '*'"
                          required
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.CODICECOMUNE) ||
                              $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="1">
                        <v-text-field
                          v-model="indirizzi.residenza.cap"
                          required
                          v-bind:label="$t('indirizzi.cap') + '*'"
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="indirizzi.residenza.telefono"
                          type="number"
                          v-bind:label="$t('indirizzi.telefono') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="indirizzi.residenza.indirizzo"
                          v-bind:label="$t('indirizzi.indirizzo') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </h4>
                </div>
              </div>

              <!--Recapito-->

              <div
                class="
                  card card-nav-tabs
                  animate__animated animate__bounceInDown
                  pa-2
                "
              >
                <h4
                  class="
                    card-header card-header-primary
                    font-weight-bold
                    grey
                    lighten-2
                    black--text
                    text--lighten-1
                    titolocard
                    body-1
                    p-2
                  "
                >
                  {{ $t("indirizzi.recapito") }} 
                  <v-btn
                    v-if="indirizzi.residenza.nazione.CODICENU == 1"
                    class="animate__animated animate__zoomIn"
                    color="primary darken-1"
                    @click="copiaDatiResidenza"
                  >
                    Copia i dati dalla Residenza
                  </v-btn>
                </h4>

                <div class="card-body">
                  <h4 class="card-title">
                    <v-row class="text-small">
                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="indirizzi.recapito.nazione"
                          :items="dd_nazione_recapito"
                          item-text="DECODIF"
                          item-value="CODICENU"
                          v-bind:label="$t('indirizzi.nazione') + '*'"
                          required
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.CODICENU) || $t('campoObbligatorio'),
                          ]"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.DECODIF }}
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="4">
                        <v-autocomplete
                          v-model="indirizzi.recapito.comune"
                          :items="dd_comuni_recapito"
                          item-text="DECODIF"
                          item-value="CODICECOMUNE"
                          v-bind:label="$t('indirizzi.comune') + '*'"
                          required
                          return-object
                          :rules="[
                            (v) =>
                              !!(v && v.CODICECOMUNE) ||
                              $t('campoObbligatorio'),
                          ]"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="1">
                        <v-text-field
                          v-model="indirizzi.recapito.cap"
                          v-bind:label="$t('indirizzi.cap') + '*'"
                          v-mask="'#####'"
                          required
                          :rules="[
                          (v) => !!v || $t('campoObbligatorio'),
                          (v) => !!v && !(v.length <5)  || $t('indirizzi.formatoCap')
                          ]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          v-model="indirizzi.recapito.telefono"
                          type="number"
                          v-bind:label="$t('indirizzi.telefono') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.indirizzo"
                          v-bind:label="$t('indirizzi.indirizzo') + '*'"
                          required
                          :rules="[(v) => !!v || $t('campoObbligatorio')]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.presso"
                          v-bind:label="$t('indirizzi.presso')"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="indirizzi.recapito.cellulare"
                          type="number"
                          v-bind:label="$t('indirizzi.cellulare')"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </h4>
                </div>
              </div>

              <!-- diocesi
              <div
                class="
                  card card-nav-tabs
                  animate__animated animate__bounceInUp
                  pa-2
                "
              >
                <h4
                  class="
                    card-header card-header-primary
                    font-weight-bold
                    grey
                    lighten-2
                    black--text
                    text--lighten-1
                    titolocard
                    body-1
                    p-2
                  "
                >
                  Diocesi
                </h4>

                <div class="card-body">
                  <h4 class="card-title body-1">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="['0-17', '18-29', '30-54', '54+']"
                          label="Collegio"
                          required
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          :items="['0-17', '18-29', '30-54', '54+']"
                          label="Diocesi"
                          required
                        ></v-select>
                      </v-col>
                    </v-row>
                  </h4>
                </div>
              </div>-->
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer
              ><small>({{ $t("campiObbligatori") }})</small></v-spacer
            >
            <v-btn color="primary darken-1" @click="validazione">
              {{ $t("conferma") }}
            </v-btn>
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '@/services/EventService.js'

export default {
  name: "indirizzi",

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    dialog: true,
    dd_nazioni: null,
    dd_nazione_recapito: [
      { CODICENU: 1, DECODIF: "ITALIA" },
      { CODICENU: 137, DECODIF: "STATO CITTÀ DEL VATICANO" },
      { CODICENU: 130, DECODIF: "SAN MARINO" },
    ],
    dd_comuni_residenza: [],
    dd_comuni_recapito: [],
  }),
  methods: {
    copiaDatiResidenza() {
      //this.indirizzi.recapito.text= "ITALIA"
      this.$store.state.indirizzi.recapito.nazione = this.$store.state.indirizzi.residenza.nazione
      this.$store.state.indirizzi.recapito.comune = this.$store.state.indirizzi.residenza.comune
      this.indirizzi.recapito.indirizzo = this.indirizzi.residenza.indirizzo;
      this.indirizzi.recapito.cap = this.indirizzi.residenza.cap;
      this.indirizzi.recapito.telefono = this.indirizzi.residenza.telefono;
    },
    carica_dd: function () {
      api
        .get("/anagrafiche/nazioni/")
        .then((r) => {
          this.dd_nazioni = r.data;
          // riga nazione non definita
          this.dd_nazioni.unshift({
            CODICENU: 0,
            DECODIF: "-- Non Definito --",
          });

          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
        
      this.carica_comuni_residenza();
      this.carica_comuni_recapito();
    },
    carica_comuni_residenza(){
      api
        .get("/anagrafiche/comuni/" + this.indirizzi.residenza.nazione.CODICENU)
        .then((r) => {
          this.dd_comuni_residenza = r.data;
        })
        .catch();
    },
    carica_comuni_recapito() {
      api
        .get("/anagrafiche/comuni/" + this.indirizzi.recapito.nazione.CODICENU)
        .then((r) => {
          this.dd_comuni_recapito = r.data;
          // ricarico i dati da store, se presenti
          // this.iscrizione.fac_scelta = this.dd_facolta.find(
          // item => item.CODICENU === this.iscrizione_store.facolta.val
          //);
        })
        .catch();
    },
    async chiudi() {
      if (!this.$refs.form.validate()) {
        await this.$store.dispatch("setStepNoCompletoEvent", 3);
      }
      this.attivo = false;
    },
    async validazione() {
      if (this.$refs.form.validate()) {
        await this.$store.dispatch("setStepCompletoEvent", 3);
        this.attivo = false;
      }
    },

    Preview_image() {
      console.log("files", this.files);
      this.files.forEach((file, f) => {
        this.readers[f] = new FileReader();
        this.readers[f].onloadend = () => {
          let fileData = this.readers[f].result;
          let imgRef = this.$refs.file[f];

          imgRef.src = fileData;
          console.log(fileData);
          // send to server here...
        };

        this.readers[f].readAsDataURL(this.files[f]);
      });
      /*if (e) {
        this.anteprimaFoto = URL.createObjectURL(e);
        this.anagrafica.fototessera = J
      } else{
         this.anteprimaFoto = ""
      }*/
    },
  },
  computed: {
    indirizzi() {
      return this.$store.state.indirizzi;
    },
  },
  mounted: function () {
    this.carica_dd();
    this.carica_comuni_recapito();
  },
  updated: function () {
    //this.carica_comuni_recapito();
  },

  watch: {
    "indirizzi.residenza.nazione": function () {
      //alert(JSON.stringify(this.anagrafica.nazioneNascita));
      this.carica_comuni_residenza();
    },
    "indirizzi.recapito.nazione": function () {
      this.carica_comuni_recapito();
    },
  },
};
</script>
